<template>
  <b-tabs
    v-if="correspondencia"
    pills
    class="w-100"
  >
    <b-tab
      title="Sobre"
      active
    >
      <b-card
        :title="correspondencia.remetente"
        :sub-title="correspondencia.destinatario"
      >
        <b-card-text>
          <p>{{ correspondencia.observacao }}</p>
        </b-card-text>
      </b-card>
    </b-tab>
    <b-tab title="Eventos">
      <b-card>
        <b-row
          b-type="flex"
          b-justify="space-between"
          class="mb-1"
        >
          <b-col
            b-type="flex"
            b-w="6"
          >
            <b-button
              variant="outline-primary"
              @click="devolver()"
            >
              <feather-icon icon="ArrowLeftIcon" />
              Devolver
            </b-button>
          </b-col>
          <b-col
            b-type="flex"
            b-w="6"
            align="right"
          >
            <b-button
              variant="primary"
              @click="confirmar()"
            >
              Receber
              <feather-icon icon="CheckIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-list-group>
          <b-list-group-item
            v-for="evento in eventos"
            :key="evento.id"
            class="d-flex justify-content-between align-items-center"
          >
            <span>{{ formatTipo(evento.tipoEvento) }}</span>
            <b-badge
              variant="primary"
              pill
              class="badge-round"
            >
              {{ new Date(evento.dataHora) | formatDatetime }}
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-tab>
  </b-tabs>
</template>

<script>
import { BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
  components: { BListGroup, BListGroupItem },
  data() {
    return {
      correspondencia: null,
    }
  },
  computed: {
    eventos() {
      return this.$store.state.correspondencia.eventos
    },
  },
  async created() {
    this.fetchCorrespondencia()
    this.fetchEventos()
  },
  methods: {
    async fetchEventos() {
      this.$store.dispatch('correspondencia/clearEventos')
      this.$store.dispatch('correspondencia/fetchEventos', {
        id: this.$route.params.id,
      })
    },
    async fetchCorrespondencia() {
      this.correspondencia = this.$store.getters['correspondencia/getOne'](
        Number(this.$route.params.id),
      )
      if (!this.correspondencia) {
        this.correspondencia = await this.$store.dispatch(
          'correspondencia/fetchOne',
          {
            id: this.$route.params.id,
          },
        ).data
      }
    },
    formatTipo(tipo) {
      if (tipo === 'CONF_ENTREGA') return 'Entrega Confirmada'
      if (tipo === 'DEVOLUCAO') return 'Devolvido'
      if (tipo === 'RECEBIMENTO') return 'Recebido no Condomínio'

      return tipo
    },
    confirmar() {
      this.$bvModal
        .msgBoxConfirm('Desejsa confirmar o recebimento?', {
          cancelVariant: 'outline-secondary',
        })
        .then(value => {
          if (value) {
            this.$loading.show()
            this.$store
              .dispatch('correspondencia/confirmar', {
                id: this.$route.params.id,
              })
              .then(() => {
                this.$loading.hide()
                this.$toast.success('Correspondência recebida')
                this.$router.back()
              })
          }
        })
        .catch(() => {
          this.$loading.hide()
          this.$toast.info('Não foi possível executar a operação no momento')
        })
    },

    devolver() {
      this.$bvModal
        .msgBoxConfirm('Desejsa devolver a correspondencia?', {
          cancelVariant: 'outline-secondary',
        })
        .then(value => {
          if (value) {
            this.$loading.show()
            this.$store
              .dispatch('correspondencia/devolver', {
                id: this.$route.params.id,
              })
              .then(() => {
                this.$loading.hide()
                this.$toast.info('Correspondência devolvida')
                this.$router.back()
              })
          }
        })
        .catch(() => {
          this.$loading.hide()
          this.$toast.info('Não foi possível executar a operação no momento')
        })
    },
  },
}
</script>
